import { GlobalToken } from 'antd';
import styled from 'styled-components';

/**
 * Shared styled wrapper for Markdown content in Chat components.
 * Handles list styling, table formatting, and inline display.
 */
export const StyledMarkdownWrapper = styled.div<{
  theme: GlobalToken;
  $softTableBorder?: boolean;
}>`
  /* prevent breakline at start */
  & {
    display: inline;
  }

  /* Prevent horizontal overflow — text must wrap within container */
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;

  pre, code {
    white-space: pre-wrap;
    word-break: break-word;
    max-width: 100%;
  }

  /* Constrain headings inside chat messages */
  h1, h2, h3, h4, h5, h6 {
    margin: 0.5em 0 0.25em;
    font-size: inherit;
    line-height: 1.4;
  }
  h3 {
    font-size: 1em;
    font-weight: 600;
  }
  ul,
  ol {
    margin-top: 1em;
    margin-bottom: 0;
    padding-left: 1.5em;
    display: flex;
    flex-direction: column;
    gap: 0.9rem;

    /* fix issue with breakline before P in LI */

    /* https://libertify.atlassian.net/browse/MED-638 */
    white-space: normal;

    /* disable from ant */
    li {
      margin-inline: 0;
      padding-inline: 0;
    }
  }

  ol {
    counter-reset: custom-counter;
    > li::before {
      content: counter(custom-counter) '. ';
      opacity: 0.5;
    }
    > li {
      counter-increment: custom-counter;
      display: block;
    }
    > li > ol {
      counter-reset: sub-counter;
      li::before {
        content: counter(sub-counter) '. ';
        opacity: 0.5;
      }
      li {
        counter-increment: sub-counter;
        display: block;
      }
    }
  }
  table {
    border-collapse: collapse;
    margin: 0.8em 0;
    border: 1px solid ${(props) => props.theme.colorBorder};

    thead tr {
      background-color: ${(props) => props.theme.colorBgContainer};
      text-align: left;
    }
    th,
    td {
      padding: 12px 10px;
    }
    td {
      border: 1px solid
        ${(props) => props.theme.colorBorder}${(props) =>
          props.$softTableBorder ? '99' : ''};
    }

    /* avoid too narrow cell */
    th {
      min-width: 100px;
    }
  }
`;
